import React, { useState, useEffect, useRef } from 'react';
import { Calendar, DateObject } from 'react-multi-date-picker';
import { getStandardDateFormat } from '../../../../Helpers/UtilityMethods';
import { useTheme, useMediaQuery } from '@mui/material';

const ResponsibilityCalendar = ({ userSelectionArray }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const containerRef = useRef(null);
  const [monthsToShow, setMonthsToShow] = useState(2);
  const [currentMonth] = useState(new Date());

  const getBackgroundColor = (date) => {
    for (const user of userSelectionArray) {
      const startDate = getStandardDateFormat(new DateObject(user.startDate));
      const endDate = getStandardDateFormat(new DateObject(user.endDate));
      const currentDate = getStandardDateFormat(date);
      if (startDate <= currentDate && currentDate <= endDate) {
        return { backgroundColor: user.color, title: user.name };
      }
    }
    return {};
  };

  const calculateMonths = (width) => {
    const minMonthWidth = 260; // Adjust based on actual calendar styling
    const spacing = 16;
    return Math.max(1, Math.floor((width - spacing) / minMonthWidth));
  };

  const updateMonths = () => {
    if (containerRef.current) {
      const width = containerRef.current.offsetWidth;
      const months = isMobile ? 1 : calculateMonths(width);
      setMonthsToShow(months);
    }
  };

  useEffect(() => {
    updateMonths();
    window.addEventListener('resize', updateMonths);
    return () => window.removeEventListener('resize', updateMonths);
  }, [isMobile]);

  return (
    <div
      ref={containerRef}
      style={{
        width: '100%',
        padding: '1rem',
        boxSizing: 'border-box',
      }}
    >
      <Calendar
        numberOfMonths={monthsToShow}
        multiple
        disableMonthPicker={true}
        disabled={monthsToShow > 1}
        disableYearPicker={true}
        weekStartDayIndex={1}
        value={new DateObject(currentMonth)}
        style={{
          width: '100%',
        }}
        mapDays={({ date }) => {
          const { backgroundColor, title } = getBackgroundColor(date);
          if (backgroundColor) {
            return {
              style: { backgroundColor },
              title,
            };
          }
        }}
      />
    </div>
  );
};

export default ResponsibilityCalendar;
